































































































/*
    * Method for pupulate text input control - STARTS
    1.  browserAutocomplete     - HTML5 autocomplete attribute set to off (or any other value that is no "on").
    2.  columns                 - For arrange the add/edit form layout. Possible Views( multiCoumn 1 to 4)
    3.  counter / maxLength     - Creates counter for input length; if no number is specified, it defaults to 25. Does not apply any validation.
    4.  create                  - A boolean value that indicates whether this field is shown in the create record form. Default value is true.
    5.  disabled                - For create a disabled input field. Tab index 'll be -1 for this field.
    6.  edit                    - A boolean value that indicates whether this field is shown in the edit record form. Default value is true.
    7.  fieldName               - Name of the field.
    8.  formCreate              - Used to find the current operation of the popup field control.
    9.  hint                    - The hint property on text fields adds the provided string beneath the text field.
    10. inline                  - Hides hint, validation errors when inline editor enabled.
    11. mailto                  - This is an email link.
    12. parentName              - Used to find the component name.
    13. placeholder             - Sets the input�s placeholder text
    14. prefix                  - Displays prefix text
    15. readonly                - For create a readonly input field. Tab index 'll be -1 for this field.
    16. record                  - Object of the field.
    17. required                - For set the current field as required field. An mandatory css class added for these fields.
    18. rules                   - Vuetify includes simple validation through the rules prop.
                                  The prop accepts an array of callbacks. While validating rules, the current v-model value will be passed to the callback.
                                  This callback should return either true or a String, the error message.
    19. showInputs              - This is using for internal purpose, to check whether all the inputs are binded.
    20. suffix                  - Displays suffix text
    21. title                   - A string that is shown on top of the table. This is optional.
    22. tooltip                   - The v-tooltip component is useful for conveying information when a user hovers over an element.
    23. tooltipList             - The v-tooltip component is useful for conveying all field information when a user hovers over an element.
*/
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import TooltipComponents from "./../../../../../Tooltips/Tooltips.vue";
import LanguageManagerForm from "@/components/common/LanguageManager/LanguageManagerForm.vue";

/*
    * Component's properties and events
*/
@Component({
   components: { TooltipComponents, LanguageManagerForm }
})

export default class TextInputComponent extends Vue  {
    /*
        * Component's props
    */
    @Prop() readonly browserAutocomplete!: any;
    @Prop() readonly columns!: any;
    @Prop() readonly counter!: any;
    @Prop() readonly create!: any;
    @Prop() readonly disabled!: any;
    @Prop() readonly edit!: any;
    @Prop() readonly fieldName!: any;
    @Prop() readonly formCreate!: any;
    @Prop() readonly hint!: any;
    @Prop() readonly inline!: any;
    @Prop() readonly mailto!: any;
    @Prop() readonly maxLength!: any;
    @Prop() readonly parentName!: any;
    @Prop() readonly password!: any;
    @Prop() readonly placeholder!: any;
    @Prop() readonly prefix!: string;
    @Prop() readonly readonly!: any;
    @Prop() readonly record!: any;
    @Prop() readonly required!: any;
    @Prop() readonly rules!: any;
    @Prop() readonly showInputs!: any;
    @Prop() readonly suffix!: any;
    @Prop() readonly title!: any;
    @Prop() readonly tooltip!: any;
    @Prop() readonly tooltipList!: any;
    @Prop() readonly mask!: any;
    @Prop() readonly languageManager!: any;
    @Prop() readonly tableName!: any;
    @Prop() readonly htmlEditor!: boolean;
    @Prop() readonly primaryKey!: any;

    /*
        * Component's variables
    */
    private tooltipIcon: boolean = false;
    private tooltipOption: boolean = false;
    private show: boolean = false;
    private translateKey: string = "";
    private showLanguageManager: boolean = false;
    
    /*
        *  A component’s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  tooltipIcon - tootip icon show in mouseover
        *  tooltipOption - tootip dialog show in mouseover
        *  translateKey - translated key field
    */
    data() {
        return { translateKey: "", tooltipIcon: false, tooltipOption: false };
    }

    /*
            * Method for inline editor input change
        */
    _txtChange() {
        let context = this.$store.state[this.parentName];

        //#.Check is dirty
        context.isDirty = true;
    }

    /*
        * It performs the dropdown option click event.
    */
    _txtClick(e) {
        let context = this.$store.state[this.parentName],
            fieldName = this.fieldName;

        if (context.card.type != context.type._form) {
            return;
        }

        //#. Check if the component is enabled redirect options
        let field = context.fields.find(x => x.value == fieldName);

        if (field.mailto && field.mailto.enabled && field.mailto.subject && context.editedIndex == -1 && context.dashboard.componentId != 0 && context.editedItem[fieldName]) {
            //#.Mail to subject event raising methods
            this.$store.dispatch(context.fileName + '/' + field.mailto.subject, { records: context.formData }).then(result => {
                field.subject = result;
            });

            setTimeout(() => {
                location.href = "mailto:" + context.editedItem[fieldName] + "?subject=" + field.subject;
            }, 50);
        } else if (field.mailto && field.mailto.enabled && context.editedIndex == -1 && context.dashboard.componentId != 0 && context.editedItem[fieldName]) {
            location.href = "mailto:" + context.editedItem[fieldName];
        }
    }

    /*
        * Method for show tooltip
    */
    _tpShowTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.tooltipOption = true;
    }

    /*
        * Method for remove tooltip
    */
    _tpRemoveTooltip() {
        if (!this.tooltip) {
            return;
        }

        this.$store.state.tooltip.showMore = false;
        this.tooltipOption = false;
        this.tooltipIcon = false;
    }   

    /*
        *  Key translator
    */
    get translator(): string {
        let context = this.$store.state[this.parentName];

        if (context && !context.keyTranslator) {
            this.translateKey = this.title;
            return this.translateKey;
        }

        this.translateKey = this.$t(this.title) || this.title;
        return this.translateKey;
    }

    showLanguageManagerForm ()
    {
        this.showLanguageManager = true;
    }

    onLanguageUpdated(entity) {
        this.record[`${entity.Field}`] = entity.EnglishText;
        this.record[`${entity.Field}French`] = entity.FrenchText;
        this.record[`${entity.Field}Spanish`] = entity.SpanishText;
    }
}
